import React, { Component } from 'react';
import { FieldTypes, timeSlotPicker, SelectOptionFields } from 'drapcode-constant';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../../common/utils/restApiHeaderUtils';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { getCurrentEnvironment } from './Util';

export default class CollectionFieldForm extends Component {
  state = {
    key: this.props.paramRow.key,
    valueFrom: this.props.paramRow.valueFrom,
    paramValue: this.props.paramRow.value,
    selectedField: '',
    dynamicFieldOptions: [],
    referenceFieldOptions: [],
    valueAction: this.props.paramRow.valueAction,
  };

  componentDidMount = async () => {
    const { fields, paramRow } = this.props;
    const { key, valueFrom } = paramRow;
    if (key && valueFrom) {
      const selectedField = fields.find((e) => e.fieldName === key);
      let dynamicFieldOptions = [];
      if (selectedField.type === FieldTypes.dynamic_option.id) {
        dynamicFieldOptions = await this.getDynamicOptions(selectedField);
      }
      let referenceFieldOptions = [];
      if ([FieldTypes.reference.id, FieldTypes.belongsTo.id].includes(selectedField.type)) {
        referenceFieldOptions = await this.getReferenceOptions(selectedField);
      }

      this.setState({
        ...this.state,
        selectedField,
        dynamicFieldOptions,
        referenceFieldOptions,
      });
    }
  };

  getDynamicOptions = async (seletedField) => {
    const { projectId, version } = this.props;
    const { collectionName, collectionField } = seletedField.refCollection;
    let dynamicFieldOptions = [];
    const header = builderSurfaceJsonContentHeader(projectId);
    await axios
      .get(`${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/`, header)
      .then((res) => {
        const items = res.data && res.data.code === 200 ? res.data.content : [];
        if (Array.isArray(items)) {
          items.forEach((item) => {
            if (item[collectionField]) {
              let optionItemLabel = item[collectionField];
              let optionItemValue = item[collectionField];
              if (optionItemValue && optionItemValue.includes('::')) {
                const itemArr = optionItemValue.split('::');
                if (itemArr && itemArr.length === 2) {
                  optionItemValue = itemArr[0].trim();
                  optionItemLabel = itemArr[1].trim();
                }
              }

              dynamicFieldOptions.push({
                value: optionItemValue,
                label: optionItemLabel,
              });
            }
          });
        }
      });
    return dynamicFieldOptions;
  };

  getReferenceOptions = async (selectedField) => {
    const { projectId, version } = this.props;
    const { collectionName, collectionField } = selectedField.refCollection;
    let referenceFieldOptions = [];
    const header = builderSurfaceJsonContentHeader(projectId);
    await axios
      .get(`${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/`, header)
      .then((res) => {
        const items = res.data && res.data.code === 200 ? res.data.content : [];
        if (Array.isArray(items)) {
          items.forEach((item) => {
            if (item[collectionField]) {
              referenceFieldOptions.push({
                value: item['uuid'],
                label: item[collectionField],
              });
            }
          });
        }
      });
    return referenceFieldOptions;
  };

  staticValueOptions = (selectedField) => {
    const { staticOptions } = selectedField;

    let staticValueOptions = [];
    staticOptions.forEach((item) => {
      if (item) {
        let optionItemLabel = item;
        let optionItemValue = item;
        if (optionItemValue && optionItemValue.includes('::')) {
          const itemArr = optionItemValue.split('::');
          if (itemArr && itemArr.length === 2) {
            optionItemValue = itemArr[0].trim();
            optionItemLabel = itemArr[1].trim();
          }
        }

        staticValueOptions.push({
          value: optionItemValue,
          label: optionItemLabel,
        });
      }
    });
    return staticValueOptions;
  };

  onKeyChange = async (event) => {
    const fieldName = event.target.value;
    const keyName = event.target.name;
    const { fields } = this.props;
    const selectedField =
      keyName === 'key' ? fields.find((e) => e.fieldName === fieldName) : this.state.selectedField;
    if (keyName === 'key') {
      let dynamicFieldOptions = [];
      if (selectedField && selectedField.type === FieldTypes.dynamic_option.id) {
        dynamicFieldOptions = await this.getDynamicOptions(selectedField);
      }
      let referenceFieldOptions = [];
      if (
        selectedField &&
        [FieldTypes.reference.id, FieldTypes.belongsTo.id].includes(selectedField.type)
      ) {
        referenceFieldOptions = await this.getReferenceOptions(selectedField);
      }
      this.setState({
        ...this.state,
        [keyName]: fieldName,
        paramValue: '',
        selectedField,
        dynamicFieldOptions,
        referenceFieldOptions,
      });
    } else {
      this.setState({
        ...this.state,
        [keyName]: fieldName,
        paramValue: '',
      });
    }

    this.props.paramRow[keyName] = fieldName;
    this.props.paramRow.value = '';
    this.props.paramRow.fieldType = selectedField ? selectedField.type : 'text';
    this.props.paramRow.isMultiSelect = selectedField ? !!selectedField.isMultiSelect : false;
    if (['dynamic_option', 'reference'].includes(selectedField.type)) {
      const currentEnvironment = getCurrentEnvironment();
      this.props.paramRow.environment = currentEnvironment;
    }
    this.props.createNewRow(this.props.paramRow);
  };

  onValueChange = ({ target: { value, type, checked } }) => {
    const finalValue = type === 'checkbox' ? checked : value;
    this.setState({
      ...this.state,
      paramValue: finalValue,
    });
    this.props.paramRow.value = finalValue;
    this.props.createNewRow(this.props.paramRow);
  };

  onActionChange = ({ target: { value } }) => {
    this.setState({
      ...this.state,
      valueAction: value,
    });
    this.props.paramRow.valueAction = value;
    this.props.createNewRow(this.props.paramRow);
  };

  onDateChange = (date) => {
    const { selectedField } = this.state;
    const { events } = this.props;
    const {
      projectDetail: { dateFormat },
    } = events;
    let isShowDateOnly =
      selectedField.extraFieldSetting && selectedField.extraFieldSetting.dateDisplayType === 'date';
    if (timeSlotPicker.includes(selectedField.type)) isShowDateOnly = false;
    if (isShowDateOnly) {
      const seletedDate = new Date(date);
      date = moment(seletedDate).format(dateFormat);
    } else date = moment(date).format('YYYY-MM-DDTHH:mm:ss');
    this.onValueChange({ target: { value: date } });
  };

  showAppendOption = (selectedField) => {
    let displayAppend = false;
    const supportedTypes = SelectOptionFields;
    const { isMultiSelect, type } = selectedField || {};
    if (isMultiSelect && supportedTypes.includes(type)) {
      displayAppend = true;
    }
    return displayAppend;
  };

  render() {
    const {
      selectedField,
      valueFrom,
      key,
      paramValue,
      dynamicFieldOptions,
      referenceFieldOptions,
      valueAction,
    } = this.state;
    const { isMultiTenantPluginInstalled, events } = this.props;
    const {
      projectDetail: { dateFormat, constants },
    } = events;
    let isShowDateOnly = false;
    if (selectedField && selectedField.extraFieldSetting) {
      isShowDateOnly = selectedField.extraFieldSetting.dateDisplayType === 'date';
    }
    if (selectedField && timeSlotPicker.includes(selectedField.type)) {
      isShowDateOnly = false;
    }
    return (
      <tr>
        <td>
          <select
            name="key"
            onChange={this.onKeyChange}
            className="form-control form-control-sm custom-select-sm"
            value={key}
          >
            <option value="">-Select One-</option>
            {this.props.fields.map((e) => (
              <option key={e.fieldName} value={e.fieldName}>
                {e.fieldTitle.en}
              </option>
            ))}
          </select>
        </td>
        <td>
          <select
            name="valueFrom"
            onChange={this.onKeyChange}
            className="form-control form-control-sm custom-select-sm"
            value={valueFrom}
          >
            <option value="event">Fixed Value</option>
            <option value="derived-field">Derived Field</option>
            <option value="app-constants">App Constants</option>
            <option value="currentLoggedInUser">Current LoggedIn User</option>
            {isMultiTenantPluginInstalled && (
              <option value="currentLoggedInUserTenant">Current LoggedIn User Tenant</option>
            )}
            <option value="SESSION_STORAGE">Browser's Session Storage</option>
            <option value="LOCAL_STORAGE">Browser's Local Storage</option>
            <option value="COOKIES">Browser's Cookies</option>
          </select>
        </td>
        {[
          'currentLoggedInUser',
          'currentLoggedInUserTenant',
          'previousActionResponse',
          'browserSessionFormData',
          'SESSION_STORAGE',
          'LOCAL_STORAGE',
          'COOKIES',
        ].includes(valueFrom) && (
          <td>
            <input
              type="text"
              name="paramValue"
              value={paramValue}
              className="form-control form-control-sm"
              onChange={this.onValueChange}
              placeholder="JSON key path"
            />
          </td>
        )}
        {valueFrom === 'derived-field' && (
          <td>
            <select
              name="paramValue"
              value={paramValue}
              className="form-control form-control-sm"
              onChange={this.onValueChange}
              placeholder="Derived Field"
            >
              <option value="">-Select One-</option>
              {this.props.utilities.map((e, index) => (
                <option
                  key={index}
                  value={JSON.stringify({ args: e.args, functionType: e.functionType })}
                >
                  {e.name}
                </option>
              ))}
            </select>
          </td>
        )}
        {valueFrom === 'app-constants' && (
          <td>
            <select
              name="text"
              value={paramValue}
              className="form-control form-control-sm"
              onChange={this.onValueChange}
              placeholder="App Constants"
            >
              <option value="">-Select One-</option>
              {constants.map((e, index) => (
                <option key={index} value={e.name}>
                  {e.name}
                </option>
              ))}
            </select>
          </td>
        )}
        {valueFrom === 'event' && (
          <td>
            {selectedField &&
              [FieldTypes.text.id, FieldTypes.large_text.id].includes(selectedField.type) && (
                <input
                  type="text"
                  name="paramValue"
                  value={paramValue}
                  className="form-control form-control-sm"
                  onChange={this.onValueChange}
                  placeholder="Value"
                />
              )}
            {selectedField && [FieldTypes.email.id].includes(selectedField.type) && (
              <input
                type="email"
                name="paramValue"
                value={paramValue}
                className="form-control form-control-sm"
                onChange={this.onValueChange}
                placeholder="Value"
              />
            )}
            {selectedField && [FieldTypes.url.id].includes(selectedField.type) && (
              <input
                type="url"
                name="paramValue"
                value={paramValue}
                className="form-control form-control-sm"
                onChange={this.onValueChange}
                placeholder="Value"
              />
            )}
            {selectedField && [FieldTypes.static_option.id].includes(selectedField.type) && (
              <select
                name="paramValue"
                value={paramValue}
                className="form-control form-control-sm"
                onChange={this.onValueChange}
                placeholder="Value"
              >
                <option value="">-Select One-</option>
                {this.staticValueOptions(selectedField).map((e, index) => (
                  <option key={index} value={e.value}>
                    {e.label}
                  </option>
                ))}
              </select>
            )}
            {selectedField && [FieldTypes.dynamic_option.id].includes(selectedField.type) && (
              <select
                name="paramValue"
                value={paramValue}
                className="form-control form-control-sm"
                onChange={this.onValueChange}
                placeholder="Value"
              >
                <option value="">-Select One-</option>
                {dynamicFieldOptions.map((e, index) => (
                  <option key={index} value={e.value}>
                    {e.label}
                  </option>
                ))}
              </select>
            )}
            {selectedField &&
              [FieldTypes.reference.id, FieldTypes.belongsTo.id].includes(selectedField.type) && (
                <select
                  name="paramValue"
                  value={paramValue}
                  className="form-control form-control-sm"
                  onChange={this.onValueChange}
                  placeholder="Value"
                >
                  <option value="">-Select One-</option>
                  {referenceFieldOptions.map((e, index) => (
                    <option key={index} value={e.value}>
                      {e.label}
                    </option>
                  ))}
                </select>
              )}
            {selectedField && [FieldTypes.boolean.id].includes(selectedField.type) && (
              <div className="form-check mr-2">
                <label className="form-check-label">
                  <input
                    type="checkbox"
                    name="paramValue"
                    className="form-check-input"
                    onChange={this.onValueChange}
                    checked={paramValue ? 'checked' : ''}
                  />
                  <span className="form-check-sign">
                    <span className="check"></span>
                  </span>
                </label>
              </div>
            )}
            {selectedField && [FieldTypes.date.id].includes(selectedField.type) && (
              <DatePicker
                selected={paramValue ? moment(paramValue, dateFormat).toDate() : paramValue}
                name={selectedField.fieldName}
                showTimeSelect={!isShowDateOnly}
                timeFormat="h:mm a"
                timeIntervals={15}
                timeCaption="Time"
                dateFormat={isShowDateOnly ? 'MMMM d, yyyy' : 'MMMM d, yyyy h:mm aa'}
                className="form-control"
                onChange={this.onDateChange}
                placeholderText={selectedField.fieldTitle['en']}
                title={selectedField.fieldTitle['en']}
              />
            )}
            {selectedField &&
              [FieldTypes.number.id, FieldTypes.unix_timestamp.id].includes(selectedField.type) && (
                <input
                  type="number"
                  name="paramValue"
                  value={paramValue}
                  className="form-control form-control-sm"
                  onChange={this.onValueChange}
                  placeholder="Value"
                />
              )}
          </td>
        )}
        <td>
          <select
            name="valueAction"
            onChange={this.onActionChange}
            className="form-control form-control-sm custom-select-sm"
            value={valueAction}
          >
            <option value="DEFAULT">Replace Value (Default)</option>
            {selectedField && this.showAppendOption(selectedField) && (
              <option value="APPEND">Append Value</option>
            )}
          </select>
        </td>
      </tr>
    );
  }
}
